import { useEffect } from "react";

export default function TokenRoute() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
console.log("entrou TokenRouter")
    if (!token) {

      window.location.href = "http://186.193.168.107:3012/login";
      return;
    }

    try {
      const dados = JSON.parse(atob(token));

      if (!dados.id_usuario) {
        throw new Error("Usuário não informado");
      }

      if (!dados.timestamp) {
        throw new Error("Data não informada");
      }

      const dataToken = new Date(dados.timestamp);
      const hoje = new Date();

      const mesmoDia =
        dataToken.getDate() === hoje.getDate() &&
        dataToken.getMonth() === hoje.getMonth() &&
        dataToken.getFullYear() === hoje.getFullYear();

      if (!mesmoDia) {
        throw new Error("Token expirado");
      }

      sessionStorage.setItem("id_usuario", dados.id_usuario);

    } catch (err) {
      console.error("Token inválido:", err);

      sessionStorage.removeItem("id_usuario");

      window.location.href = "http://186.193.168.107:3012/login";
    }
  }, []);

  return null;
}